// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","wrapper":"LinksList_wrapper__oDOfN","isFullWidth":"LinksList_isFullWidth__FpNRj","item":"LinksList_item__W356M"};